import React, { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { media } from '../../../../../shared/lib/styles';

export interface Props {
    active: boolean;
}

const animateScribble = keyframes`
    to {
        stroke-dashoffset: 0;
    }
`;

const SVGWrapper = styled.span`
    background: transparent;
    opacity: 0;
`;

const Scribble = styled.span`
    position: relative;
    display: block;
    width: 10px;
    height: 10px;
    background: transparent;
    z-index: 5;

    &[data-active='true'] {
        ${SVGWrapper} {
            opacity: 1;
        }
    }

    @media ${media('small', 'medium')} {
        display: none !important;
    }
`;

const MarkDesignScribble = styled(Scribble)`
    display: block;
    float: right;
    margin-right: 40%;

    ${SVGWrapper} {
        position: absolute;
        width: 366px;
        height: 141px;
        bottom: 0;
        left: 0;
    }

    &[data-active='true'] {
        .line {
            stroke-dasharray: 1500;
            stroke-dashoffset: 1500;
            animation-name: ${animateScribble};
            animation-duration: 0.5s;
            animation-timing-function: ease-in;
            animation-delay: 1.5s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
        }

        .circle {
            stroke-dasharray: 800;
            stroke-dashoffset: 800;
            animation-name: ${animateScribble};
            animation-duration: 1s;
            animation-timing-function: ease-in;
            animation-delay: 1s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
        }
    }
`;

const UnderlineTextScribble = styled(Scribble)`
    ${SVGWrapper} {
        position: absolute;
        width: 171px;
        height: 36px;
        top: 10px;
        left: -50px;
    }

    &[data-active='true'] {
        .line {
            stroke-dasharray: 1500;
            stroke-dashoffset: 1500;
            animation-name: ${animateScribble};
            animation-duration: 2s;
            animation-timing-function: ease-in;
            animation-delay: 2.5s;
            animation-iteration-count: 1;
            animation-direction: normal;
            animation-fill-mode: forwards;
            animation-play-state: running;
        }
    }
`;

export const MarkDesign = React.forwardRef(({ active }: Props, ref: React.Ref<HTMLSpanElement>) => (
    <MarkDesignScribble ref={ref} data-active={active}>
        <SVGWrapper>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="363"
                height="139"
                viewBox="0 0 363 139"
            >
                <path
                    className="line"
                    d="M348,15C215.5,18.4,113.9,79.2,1,137"
                    fillOpacity="null"
                    strokeOpacity="null"
                    strokeWidth="4"
                    stroke="#fe5f50"
                    fill="none"
                />

                <path
                    className="circle"
                    d="M337,16.7c3.2,15.1,27.3,14.9,24-2c-2.9-14.7-24.2-18.1-24.4,0.8"
                    fillOpacity="null"
                    strokeOpacity="null"
                    strokeWidth="4"
                    stroke="#fe5f50"
                    fill="none"
                />
            </svg>
        </SVGWrapper>
    </MarkDesignScribble>
));
MarkDesign.displayName = 'MarkDesign';

export const UnderlineText = React.forwardRef(
    ({ active }: Props, ref: React.Ref<HTMLSpanElement>) => (
        <UnderlineTextScribble ref={ref} data-active={active}>
            <SVGWrapper>
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="172"
                    height="37"
                    x="0px"
                    y="0px"
                    viewBox="0 0 172 37"
                >
                    <g transform="translate(-309.000000, -4985.000000)">
                        <path
                            d="M340.8,4988.8c4.1-0.3,9.1-3.4,12.4-0.8c2.2,1.7-8.4,4.1-6.1,5.8c7,5.2,28.7,0.2,24.9,8.1
			c-5.2,10.7-44.5,5.1-34.1,11c13.8,7.9,33.2-9.8,47.7-3.2c32.1,14.6-203.2,10,29.3,3.8c6.1-0.2-12,2.1-17.7,4.1
			c-0.6,0.2,0.2,1.8,0.9,1.8l9.5,0.7c16-0.8,32.1-2.1,48-3.7c7.7-0.8,15.2-2.7,22.9-3.4c2.7-0.2-5.5,0.8-8,2
            c-1.7,0.8-2.8,2.6-4.2,3.9"
                            className="line"
                            strokeWidth="4"
                            stroke="#fe5f50"
                            fill="none"
                        />
                    </g>
                </svg>
            </SVGWrapper>
        </UnderlineTextScribble>
    )
);
UnderlineText.displayName = 'UnderlineText';
